"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInseeCode = exports.getLabelFromInseeCode = void 0;
const constants_1 = require("../constants");
function getLabelFromInseeCode(inseeCode) {
    return constants_1.INSEE_CODES[inseeCode] || '';
}
exports.getLabelFromInseeCode = getLabelFromInseeCode;
function isValidInseeCode(inseeCode) {
    return !!constants_1.INSEE_CODES[inseeCode];
}
exports.isValidInseeCode = isValidInseeCode;
